(function () {
  if (window.LMFreeGiftControllerInitialized) {
    return;
  }

  window.LMFreeGiftControllerInitialized = true;

  var state = {
    busy: false,
    queued: false,
    savingSelection: false,
    checkoutStarted: false,
    timer: null,
    giftWasPresent: null
  };

  function getShopifyRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function getRoute(path) {
    var root = getShopifyRoot();
    var cleanPath = String(path || '').replace(/^\/+/, '');

    return root + cleanPath;
  }

  function getGiftRoot() {
    return document.querySelector(
      '[data-lm-free-gift]'
    );
  }

  function getGiftRoots() {
    return Array.from(
      document.querySelectorAll(
        '[data-lm-free-gift]'
      )
    );
  }

  function getDrawerGiftRoot() {
    return document.querySelector(
      '#cart-drawer [data-lm-free-gift]'
    );
  }

  function updateAllVisualStates(cart) {
    getGiftRoots().forEach(
      function (root) {
        var config = getConfig(root);

        if (!config) {
          return;
        }

        updateVisualState(
          root,
          cart,
          config
        );
      }
    );
  }

  function getConfig(root) {
    if (!root) {
      return null;
    }

    return {
      root: root,

      logged:
        root.getAttribute(
          'data-customer-logged'
        ) === 'true',

      goal: Number(
        root.getAttribute(
          'data-goal'
        ) || 0
      ),

      productId: Number(
        root.getAttribute(
          'data-product-id'
        ) || 0
      ),

      sectionId:
        root.getAttribute(
          'data-section-id'
        ) || 'cart-drawer',

      progressTemplate:
        root.getAttribute(
          'data-progress-template'
        ) ||
        'Faltam [valor] para você ganhar sua camiseta.',

      successTemplate:
        root.getAttribute(
          'data-success-template'
        ) ||
        'Presente garantido! Sua camiseta foi adicionada ao pedido.',

      guestTemplate:
        root.getAttribute(
          'data-guest-template'
        ) ||
        'Entre na sua conta para participar da campanha.'
    };
  }

  function formatMoney(cents) {
    var currency = 'BRL';

    if (
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active
    ) {
      currency =
        window.Shopify.currency.active;
    }

    try {
      return new Intl.NumberFormat(
        'pt-BR',
        {
          style: 'currency',
          currency: currency
        }
      ).format(
        Number(cents || 0) / 100
      );
    } catch (error) {
      return (
        'R$ ' +
        (
          Number(cents || 0) / 100
        )
          .toFixed(2)
          .replace('.', ',')
      );
    }
  }

  function fetchCart() {
    return fetch(
      getRoute(
        'cart.js?_=' + Date.now()
      ),
      {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          Accept: 'application/json'
        }
      }
    ).then(function (response) {
      if (!response.ok) {
        throw new Error(
          'Não foi possível consultar o carrinho.'
        );
      }

      return response.json();
    });
  }

  function postCart(
    endpoint,
    payload
  ) {
    return fetch(
      getRoute(endpoint),
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type':
            'application/json',
          Accept:
            'application/json'
        },
        body: JSON.stringify(payload)
      }
    ).then(function (response) {
      if (!response.ok) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (errorData) {
            throw new Error(
              errorData.description ||
              errorData.message ||
              'Não foi possível atualizar o carrinho.'
            );
          });
      }

      return response.json();
    });
  }

  function getGiftItems(
    cart,
    config
  ) {
    return cart.items.filter(
      function (item) {
        return (
          Number(item.product_id) ===
          Number(config.productId)
        );
      }
    );
  }

  function getEligibleTotal(
    cart,
    config
  ) {
    return cart.items.reduce(
      function (total, item) {
        if (
          Number(item.product_id) ===
          Number(config.productId)
        ) {
          return total;
        }

        return (
          total +
          Number(
            item.final_line_price || 0
          )
        );
      },
      0
    );
  }

  function getSavedVariantId(cart) {
    if (
      !cart ||
      !cart.attributes
    ) {
      return 0;
    }

    return Number(
      cart.attributes
        .lm_gift_variant_id || 0
    );
  }

  function variantExistsInSelect(
    root,
    variantId
  ) {
    if (!root || !variantId) {
      return false;
    }

    var select = root.querySelector(
      '[data-lm-gift-variant]'
    );

    if (!select) {
      return false;
    }

    return Boolean(
      select.querySelector(
        'option[value="' +
        String(variantId) +
        '"]'
      )
    );
  }

  function setSelectValue(
    root,
    variantId
  ) {
    if (!root) {
      return;
    }

    var select = root.querySelector(
      '[data-lm-gift-variant]'
    );

    if (!select) {
      return;
    }

    if (
      variantId &&
      variantExistsInSelect(
        root,
        variantId
      )
    ) {
      select.value =
        String(variantId);
    } else {
      select.value = '';
    }
  }

  function getSelectedVariantTitle(
    root
  ) {
    if (!root) {
      return '';
    }

    var select = root.querySelector(
      '[data-lm-gift-variant]'
    );

    if (
      !select ||
      !select.value ||
      select.selectedIndex < 0
    ) {
      return '';
    }

    return (
      select.options[
        select.selectedIndex
      ].textContent || ''
    ).trim();
  }

  function isCorrectGiftLine(
    item,
    selectedVariantId
  ) {
    if (!item) {
      return false;
    }

    var giftMarker =
      item.properties &&
      String(
        item.properties
          ._lm_free_gift
      ) === 'true';

    return (
      Number(item.variant_id) ===
        Number(selectedVariantId) &&
      Number(item.quantity) === 1 &&
      giftMarker
    );
  }

  function updateCartCount(cart) {
    if (!cart) {
      return;
    }

    var selectors = [
      '[data-cart-count]',
      '.cart-count',
      '.header__cart-count',
      'cart-count'
    ];

    selectors.forEach(
      function (selector) {
        document
          .querySelectorAll(selector)
          .forEach(function (element) {
            element.textContent =
              String(
                cart.item_count || 0
              );
          });
      }
    );
  }

  function updateVisualState(
    root,
    cart,
    config
  ) {
    if (
      !root ||
      !cart ||
      !config ||
      !config.goal
    ) {
      return;
    }

    var giftItems =
      getGiftItems(
        cart,
        config
      );

    var eligibleTotal =
      getEligibleTotal(
        cart,
        config
      );

    var remaining = Math.max(
      0,
      config.goal -
      eligibleTotal
    );

    var progress = Math.min(
      100,
      Math.max(
        0,
        (
          eligibleTotal /
          config.goal
        ) * 100
      )
    );

    var eligible =
      eligibleTotal >=
      config.goal;

    var selectedVariantId =
      getSavedVariantId(cart);

    var selectedVariantValid =
      variantExistsInSelect(
        root,
        selectedVariantId
      );

    var correctGift =
      giftItems.length === 1 &&
      isCorrectGiftLine(
        giftItems[0],
        selectedVariantId
      );

    var progressTrack =
      root.querySelector(
        '[data-lm-gift-progress]'
      );

    var progressFill =
      root.querySelector(
        '[data-lm-gift-progress-fill]'
      );

    var message =
      root.querySelector(
        '[data-lm-gift-message]'
      );

    var status =
      root.querySelector(
        '[data-lm-gift-status]'
      );

    var helper =
      root.querySelector(
        '[data-lm-gift-helper]'
      );

    var campaignTitle =
      root.querySelector(
        '[data-lm-gift-title]'
      );

    if (progressFill) {
    progressFill.setAttribute(
        'data-progress-target',
        String(progress)
    );

    window.requestAnimationFrame(
        function () {
        progressFill.style.width =
            progress + '%';
        }
    );
    }

    if (progressTrack) {
      progressTrack.setAttribute(
        'aria-valuenow',
        String(
          Math.round(progress)
        )
      );
    }

    root.classList.toggle(
      'is-eligible',
      eligible
    );

    root.classList.toggle(
      'is-added',
      Boolean(
        config.logged &&
        eligible &&
        correctGift
      )
    );

    root.classList.toggle(
      'is-guest',
      !config.logged
    );


        /*
    * Atualiza o título principal da campanha.
    *
    * Estado padrão:
    * GANHE UMA CAMISETA GRÁTIS
    *
    * Cliente logado e meta atingida:
    * ESCOLHA SEU TAMANHO
    *
    * Brinde corretamente adicionado:
    * VOCÊ GANHOU UMA CAMISETA GRÁTIS
    */
    if (campaignTitle) {
      var defaultCampaignTitle =
        campaignTitle.getAttribute(
          'data-default-title'
        ) ||
        'GANHE UMA CAMISETA GRÁTIS';

      var giftWasWon =
        Boolean(
          config.logged &&
          eligible &&
          correctGift
        );

      var waitingForSize =
        Boolean(
          config.logged &&
          eligible &&
          !correctGift
        );

      campaignTitle.classList.toggle(
        'is-gift-won',
        giftWasWon
      );

      campaignTitle.classList.toggle(
        'is-size-selection',
        waitingForSize
      );

      if (giftWasWon) {
        campaignTitle.textContent =
          'VOCÊ GANHOU UMA CAMISETA GRÁTIS';

      } else if (waitingForSize) {
        campaignTitle.textContent =
          'ESCOLHA SEU TAMANHO';

      } else {
        campaignTitle.textContent =
          defaultCampaignTitle;
      }
    }

    if (config.logged) {
      setSelectValue(
        root,
        selectedVariantValid
          ? selectedVariantId
          : 0
      );
    }

    if (!config.logged) {
      if (message) {
        if (eligible) {
          message.textContent =
            'Você desbloqueou sua camiseta! ' +
            config.guestTemplate;
        } else {
          message.textContent =
            config.progressTemplate.replace(
              '[valor]',
              formatMoney(remaining)
            ) +
            ' ' +
            config.guestTemplate;
        }
      }

      if (status) {
        status.textContent =
          'FAÇA LOGIN PARA DESBLOQUEAR';
      }

      return;
    }

    if (!eligible) {
      if (message) {
        message.textContent =
          config.progressTemplate.replace(
            '[valor]',
            formatMoney(remaining)
          );
      }

      if (status) {
        status.textContent =
          'SEU PRÓXIMO PRESENTE';
      }

      if (helper) {
        helper.textContent =
          'Você pode deixar seu tamanho escolhido antes de atingir a meta.';
      }

      return;
    }

    if (correctGift) {
      var variantTitle =
        giftItems[0].variant_title ||
        getSelectedVariantTitle(root);

      if (message) {
        message.textContent =
          config.successTemplate +
          (
            variantTitle
              ? ' Tamanho ' +
                variantTitle +
                '.'
              : ''
          );
      }

      if (status) {
        status.textContent =
          'PRESENTE GARANTIDO';
      }

      if (helper) {
        helper.textContent =
          'Para trocar o tamanho, selecione outra opção.';
      }

      return;
    }

    if (selectedVariantValid) {
      if (message) {
        message.textContent =
          'Meta atingida! Sua camiseta será adicionada automaticamente.';
      }

      if (status) {
        status.textContent =
          'ADICIONANDO PRESENTE';
      }

      if (helper) {
        helper.textContent =
          'Aguarde enquanto atualizamos seu carrinho.';
      }

      return;
    }

    if (message) {
      message.textContent =
        'Meta atingida! Escolha o tamanho da sua camiseta.';
    }

    if (status) {
      status.textContent =
        'ESCOLHA SEU TAMANHO';
    }

    if (helper) {
      helper.textContent =
        'Selecione um tamanho disponível para receber o presente.';
    }
  }

  function getSectionUrl(
    sectionId
  ) {
    var url = new URL(
      getShopifyRoot(),
      window.location.origin
    );

    url.searchParams.set(
      'section_id',
      sectionId
    );

    url.searchParams.set(
      '_',
      String(Date.now())
    );

    return url.toString();
  }

  function replaceDrawerPart(
    currentDrawer,
    newDrawer,
    selector
  ) {
    var currentPart =
      currentDrawer.querySelector(
        selector
      );

    var newPart =
      newDrawer.querySelector(
        selector
      );

    if (
      currentPart &&
      newPart
    ) {
      currentPart.replaceWith(
        document.importNode(
          newPart,
          true
        )
      );

      return;
    }

    if (
      currentPart &&
      !newPart
    ) {
      currentPart.remove();
    }
  }

  function refreshDrawer(config) {
    var drawerRoot =
      getDrawerGiftRoot();

    var drawerConfig =
      getConfig(drawerRoot) || config;

    if (
      !drawerConfig ||
      !drawerConfig.sectionId
    ) {
      return Promise.resolve();
    }

    var currentProgressFill =
  document.querySelector(
    '[data-lm-gift-progress-fill]'
  );

        var previousProgressWidth = 0;

        if (currentProgressFill) {
        previousProgressWidth =
            parseFloat(
            currentProgressFill.style.width
            ) || 0;
        }

    return fetch(
      getSectionUrl(
        drawerConfig.sectionId
      ),
      {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          Accept: 'text/html'
        }
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Não foi possível atualizar a visualização do carrinho.'
          );
        }

        return response.text();
      })
      .then(function (html) {
        var parser =
          new DOMParser();

        var parsedDocument =
          parser.parseFromString(
            html,
            'text/html'
          );

        var currentDrawer =
          document.querySelector(
            '#cart-drawer'
          );

        var newDrawer =
          parsedDocument.querySelector(
            '#cart-drawer'
          );

        if (
          !currentDrawer ||
          !newDrawer
        ) {
          return;
        }

        /*
         * Atualiza apenas os pontos necessários.
         * O elemento externo do drawer permanece intacto,
         * preservando seu estado e seus controles.
         */
        replaceDrawerPart(
          currentDrawer,
          newDrawer,
          '[data-lm-free-gift]'
        );

        var refreshedProgressFill =
  document.querySelector(
    '[data-lm-gift-progress-fill]'
  );

if (refreshedProgressFill) {
  var targetProgress =
    parseFloat(
      refreshedProgressFill.getAttribute(
        'data-progress-target'
      )
    );

  if (isNaN(targetProgress)) {
    targetProgress =
      parseFloat(
        refreshedProgressFill.style.width
      ) || 0;
  }

  refreshedProgressFill.style.transition =
    'none';

  refreshedProgressFill.style.width =
    previousProgressWidth + '%';

  refreshedProgressFill.offsetWidth;

  refreshedProgressFill.style.transition = '';

  window.requestAnimationFrame(
    function () {
      window.requestAnimationFrame(
        function () {
          refreshedProgressFill.style.width =
            targetProgress + '%';
        }
      );
    }
  );
}

        replaceDrawerPart(
          currentDrawer,
          newDrawer,
          '.cart-drawer__items'
        );

        replaceDrawerPart(
          currentDrawer,
          newDrawer,
          '.cart-drawer__footer'
        );
      });
  }

  function refreshCartPage() {
    var currentHost =
      document.querySelector(
        '[data-lm-cart-page-free-gift-host]'
      );

    if (!currentHost) {
      return Promise.resolve();
    }

    var sectionId =
      currentHost.getAttribute(
        'data-lm-cart-page-section-id'
      );

    if (!sectionId) {
      return Promise.resolve();
    }

    return fetch(
      getSectionUrl(sectionId),
      {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          Accept: 'text/html'
        }
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Não foi possível atualizar a página do carrinho.'
          );
        }

        return response.text();
      })
      .then(function (html) {
        var parser =
          new DOMParser();

        var parsedDocument =
          parser.parseFromString(
            html,
            'text/html'
          );

        var newHost =
          parsedDocument.querySelector(
            '[data-lm-cart-page-free-gift-host]'
          );

        if (newHost) {
          currentHost.replaceWith(
            document.importNode(
              newHost,
              true
            )
          );
        }

        var currentOrderBody =
          document.querySelector(
            '.shopify-section--main-cart ' +
            '.order-summary__body'
          );

        var newOrderBody =
          parsedDocument.querySelector(
            '.order-summary__body'
          );

        if (
          currentOrderBody &&
          newOrderBody
        ) {
          currentOrderBody.replaceWith(
            document.importNode(
              newOrderBody,
              true
            )
          );
        }

        var currentCartFooter =
          document.querySelector(
            '.shopify-section--main-cart ' +
            '.cart-footer'
          );

        var newCartFooter =
          parsedDocument.querySelector(
            '.cart-footer'
          );

        if (
          currentCartFooter &&
          newCartFooter
        ) {
          currentCartFooter.replaceWith(
            document.importNode(
              newCartFooter,
              true
            )
          );
        }
      });
  }

  function refreshCartInterfaces(config) {
    return Promise.all([
      refreshDrawer(config),
      refreshCartPage()
    ]).then(function () {
      return undefined;
    });
  }

  function removeGiftItems(
    giftItems
  ) {
    if (!giftItems.length) {
      return Promise.resolve();
    }

    var updates = {};

    giftItems.forEach(
      function (item) {
        updates[item.key] = 0;
      }
    );

    return postCart(
      'cart/update.js',
      {
        updates: updates
      }
    );
  }

  function addGift(
    variantId
  ) {
    return postCart(
      'cart/add.js',
      {
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: {
              _lm_free_gift: 'true',
              _lm_free_gift_campaign:
                'gift_54990'
            }
          }
        ]
      }
    );
  }

  function clearSavedVariant() {
    return postCart(
      'cart/update.js',
      {
        attributes: {
          lm_gift_variant_id: '',
          lm_gift_variant_title: ''
        }
      }
    );
  }

  /*
       * 
       * Ajuste de remoção.
       */


    async function removeGiftByCustomer(
    giftLine
  ) {
    if (
      !giftLine ||
      state.busy ||
      state.savingSelection ||
      state.checkoutStarted
    ) {
      return;
    }

    var lineKey =
      giftLine.getAttribute(
        'data-lm-free-gift-line-key'
      );

    if (!lineKey) {
      return;
    }

    var root =
      getGiftRoot();

    var config =
      getConfig(root);

    if (!config) {
      return;
    }

    state.busy = true;
    state.savingSelection = true;

    try {
      /*
       * Remove o presente e apaga a escolha
       * de tamanho na mesma requisição.
       *
       * Dessa maneira, o sincronizador nunca
       * encontra o carrinho sem o presente,
       * mas ainda com uma variante selecionada.
       */
      var updates = {};
      updates[lineKey] = 0;

      await postCart(
        'cart/update.js',
        {
          updates: updates,

          attributes: {
            lm_gift_variant_id: '',
            lm_gift_variant_title: ''
          }
        }
      );

      var cart =
        await fetchCart();

      state.giftWasPresent = false;

      updateCartCount(cart);

      await refreshCartInterfaces(
        config
      );

      updateAllVisualStates(cart);

      document.dispatchEvent(
        new CustomEvent(
          'cart:updated',
          {
            detail: {
              source:
                'lm-free-gift'
            }
          }
        )
      );
    } catch (error) {
      console.error(
        'LM Free Gift:',
        error
      );

      showError(
        'Não foi possível remover o presente. Tente novamente.'
      );
    } finally {
      state.savingSelection = false;
      state.busy = false;
      state.queued = false;
    }
  }

  function saveSelectedVariant(
    variantId,
    variantTitle
  ) {
    return postCart(
      'cart/update.js',
      {
        attributes: {
          lm_gift_variant_id:
            variantId
              ? String(variantId)
              : '',

          lm_gift_variant_title:
            variantId
              ? String(
                  variantTitle || ''
                )
              : ''
        }
      }
    );
  }

  function showError(messageText) {
    getGiftRoots().forEach(
      function (root) {
        var message =
          root.querySelector(
            '[data-lm-gift-message]'
          );

        if (message) {
          message.textContent =
            messageText;
        }
      }
    );
  }

  async function synchronizeGift() {
    if (
      state.checkoutStarted
    ) {
      return;
    }

    if (
      state.savingSelection
    ) {
      state.queued = true;
      return;
    }

    if (state.busy) {
      state.queued = true;
      return;
    }

    var root =
      getGiftRoot();

    var config =
      getConfig(root);

    if (
      !root ||
      !config ||
      !config.goal ||
      !config.productId
    ) {
      return;
    }

    state.busy = true;

    try {
      var cart =
        await fetchCart();

      updateCartCount(cart);

      updateAllVisualStates(cart);

      var giftItems =
        getGiftItems(
          cart,
          config
        );

      var eligibleTotal =
        getEligibleTotal(
          cart,
          config
        );

      var eligible =
        eligibleTotal >=
        config.goal;

      var selectedVariantId =
        getSavedVariantId(cart);

      var selectedVariantValid =
        selectedVariantId > 0 &&
        variantExistsInSelect(
          root,
          selectedVariantId
        );

              /*
      * Detecta quando o presente existia no carrinho
      * e foi removido manualmente pelo cliente.
      *
      * Sem essa verificação, o sincronizador encontra
      * o tamanho ainda salvo e adiciona o produto novamente.
      */
      var giftIsPresent =
        giftItems.length > 0;

      var giftWasRemovedByCustomer =
        state.giftWasPresent === true &&
        !giftIsPresent &&
        config.logged &&
        eligible &&
        selectedVariantId > 0;

      if (giftWasRemovedByCustomer) {
        await clearSavedVariant();

        cart = await fetchCart();

        state.giftWasPresent = false;

        updateCartCount(cart);

        await refreshCartInterfaces(
          config
        );

        updateAllVisualStates(cart);

        return;
      }

      /*
      * Guarda o estado atual para comparar
      * na próxima atualização do carrinho.
      */
      state.giftWasPresent =
        giftIsPresent;

      /*
       * Cliente guest ou carrinho abaixo da meta:
       * nenhuma linha do produto-brinde pode permanecer.
       */
      if (
        !config.logged ||
        !eligible
      ) {
        if (giftItems.length) {
          await removeGiftItems(
            giftItems
          );

          cart =
            await fetchCart();

          updateCartCount(cart);

          await refreshCartInterfaces(
            config
          );

          updateAllVisualStates(cart);
        }

        return;
      }

      /*
       * O tamanho salvo deixou de existir
       * ou ficou sem estoque.
       */
      if (
        selectedVariantId &&
        !selectedVariantValid
      ) {
        await clearSavedVariant();

        if (giftItems.length) {
          await removeGiftItems(
            giftItems
          );
        }

        cart =
          await fetchCart();

        updateCartCount(cart);

        await refreshCartInterfaces(
          config
        );

        showError(
          'O tamanho escolhido não está mais disponível. Selecione outra opção.'
        );

        return;
      }

      /*
       * A cliente ainda não escolheu o tamanho.
       * Não adicionamos uma variante aleatória.
       */
      if (!selectedVariantId) {
        if (giftItems.length) {
          await removeGiftItems(
            giftItems
          );

          cart =
            await fetchCart();

          updateCartCount(cart);

          await refreshCartInterfaces(
            config
          );
        }

        return;
      }

      var correctGift =
        giftItems.length === 1 &&
        isCorrectGiftLine(
          giftItems[0],
          selectedVariantId
        );

      /*
       * Estado correto: não realiza nenhuma chamada.
       */
      if (correctGift) {
        return;
      }

      /*
       * Remove qualquer variante anterior,
       * duplicidade ou inclusão não autorizada.
       */
      if (giftItems.length) {
        await removeGiftItems(
          giftItems
        );
      }

      await addGift(
        selectedVariantId
      );

      cart =
        await fetchCart();

      state.giftWasPresent = true;

      updateCartCount(cart);

      await refreshCartInterfaces(
        config
      );

      updateAllVisualStates(cart);
    } catch (error) {
      console.error(
        'LM Free Gift:',
        error
      );

      showError(
        error.message ||
        'Não foi possível atualizar o presente. Tente novamente.'
      );
    } finally {
      state.busy = false;

      if (state.queued) {
        state.queued = false;
        scheduleSync(150);
      }
    }
  }

  function scheduleSync(delay) {
    if (
      state.checkoutStarted
    ) {
      return;
    }

    window.clearTimeout(
      state.timer
    );

    state.timer =
      window.setTimeout(
        synchronizeGift,
        typeof delay === 'number'
          ? delay
          : 400
      );
  }


    /*
   * Remoção voluntária do presente.
   *
   * Usa capture=true para executar antes do
   * controlador padrão de remoção do tema.
   */
  /*
 * Intercepta a remoção do presente antes
 * do controlador nativo do tema Prestige.
 */
window.addEventListener(
  'click',
  function (event) {
    var target = event.target;

    if (!(target instanceof Element)) {
      return;
    }

    /*
     * Primeiro identifica se o clique aconteceu
     * dentro de uma linha marcada como presente.
     */
    var giftLine = target.closest(
      '[data-lm-free-gift-line]'
    );

    if (!giftLine) {
      return;
    }

    /*
     * Aceita qualquer controle clicável dentro
     * da linha que possa representar remoção.
     */
    var removeControl = target.closest(
      'a, button, line-item-remove, ' +
      '[data-line-item-remove], ' +
      '[role="button"]'
    );

    if (!removeControl) {
      return;
    }

    /*
     * Evita tratar botões de quantidade como remoção,
     * salvo quando o próprio botão possui indicação
     * explícita de remoção.
     */
    var isRemoveControl =
      removeControl.matches(
        'line-item-remove, ' +
        '[data-line-item-remove], ' +
        'button[name="remove"]'
      ) ||
      (
        removeControl.tagName === 'A' &&
        (
          removeControl.href.indexOf(
            '/cart/change'
          ) !== -1 ||
          removeControl.href.indexOf(
            '/cart/update'
          ) !== -1
        )
      ) ||
      removeControl.getAttribute(
        'aria-label'
      ) &&
      /remover|remove|excluir/i.test(
        removeControl.getAttribute(
          'aria-label'
        )
      );

    if (!isRemoveControl) {
      return;
    }

    /*
     * Impede completamente que o Prestige
     * processe a remoção por conta própria.
     */
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    /*
     * Evita clique duplo enquanto a remoção
     * é processada.
     */
    removeControl.setAttribute(
      'aria-busy',
      'true'
    );

    removeControl.style.pointerEvents =
      'none';

    /*
     * Volta imediatamente todos os seletores
     * para a opção neutra.
     */
    document
      .querySelectorAll(
        '[data-lm-gift-variant]'
      )
      .forEach(function (select) {
        select.value = '';
        select.selectedIndex = 0;
        select.disabled = true;
      });

    removeGiftByCustomer(
      giftLine
    );
  },
  true
);


  document.addEventListener(
    'change',
    function (event) {
      var select =
        event.target.closest(
          '[data-lm-gift-variant]'
        );

      if (!select) {
        return;
      }

      if (
        state.checkoutStarted
      ) {
        return;
      }

      var variantId =
        Number(
          select.value || 0
        );

      var variantTitle = '';

      if (
        variantId &&
        select.selectedIndex >= 0
      ) {
        variantTitle =
          (
            select.options[
              select.selectedIndex
            ].textContent || ''
          ).trim();
      }

      state.savingSelection = true;
      select.disabled = true;

      saveSelectedVariant(
        variantId,
        variantTitle
      )
        .then(function () {
          state.savingSelection =
            false;

          scheduleSync(50);
        })
        .catch(function (error) {
          state.savingSelection =
            false;

          select.disabled = false;

          console.error(
            'LM Free Gift:',
            error
          );

          showError(
            'Não foi possível salvar o tamanho. Tente novamente.'
          );
        });
    }
  );

  document.addEventListener(
    'cart:updated',
    function (event) {
      if (
        event.detail &&
        event.detail.source ===
          'lm-free-gift'
      ) {
        return;
      }

      scheduleSync(350);
    }
  );

  document.addEventListener(
    'cart:change',
    function (event) {
      if (
        event.detail &&
        event.detail.baseEvent ===
          'lm-free-gift'
      ) {
        return;
      }

      scheduleSync(450);
    }
  );

  document.addEventListener(
    'cart:refresh',
    function () {
      scheduleSync(500);
    }
  );

  document.addEventListener(
    'shopify:section:load',
    function () {
      scheduleSync(300);
    }
  );

  document.addEventListener(
    'click',
    function (event) {
      var checkoutButton =
        event.target.closest(
          '.cart-drawer__footer button[name="checkout"], ' +
          '.cart-drawer__footer [name="checkout"], ' +
          '.cart-page button[name="checkout"], ' +
          '.cart-page [name="checkout"]'
        );

      if (checkoutButton) {
        state.checkoutStarted =
          true;

        window.clearTimeout(
          state.timer
        );

        /*
         * Não impedimos nem atrasamos o checkout.
         */
        return;
      }

      var cartAction =
        event.target.closest(
          'button[name="add"], ' +
          'line-item-quantity button, ' +
          '.quantity-selector button, ' +
          '[data-line-item-remove], ' +
          '[data-cart-toggle], ' +
          '[href="/cart"], ' +
          '[href$="/cart"]'
        );

      if (cartAction) {
        scheduleSync(900);
      }
    }
  );

  document.addEventListener(
    'submit',
    function (event) {
      if (
        event.target.matches(
          '.cart-drawer__footer, .cart-page'
        )
      ) {
        state.checkoutStarted =
          true;

        window.clearTimeout(
          state.timer
        );
      }
    }
  );

  window.addEventListener(
    'pageshow',
    function () {
      state.checkoutStarted =
        false;

      scheduleSync(250);
    }
  );

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        scheduleSync(450);
      },
      {
        once: true
      }
    );
  } else {
    scheduleSync(450);
  }
})();